// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table{
    padding: 40px 20px;
    
}


.table-head {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-row-gap: 10px;
    grid-column-gap:10px ;
    /* position: sticky; */
}

.india-head>div{
    /* background:#6c757d !important; */
    
}


.table-body{
    max-height: calc(100vh - 440px);
    overflow-y: scroll;
}

.table-head>div{
    font-size: 15px;
    font-weight: 900;
    padding: 1.25rem 0.5rem 0.75rem;
    text-align: center;
    /* background: #212130 ; */
    justify-content: space-between;
    left: 0;
    /* position: sticky; */
  
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
    /* padding: 0.5rem; */

}

.table-body>div{
    font-size: 15px;
}

.table-body>div>div:nth-child(1) {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-row-gap: 10px;
    grid-column-gap:10px ;
}

.table-body>div>div:nth-child(1)>div{
    
    font-weight: 900;
    padding: 1.25rem 0.5rem 0.75rem;
    text-align: center;
    /* background: #212130 !important; */
    justify-content: space-between;
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 11;
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
    /* padding: 0.5rem; */
}



.table-body>div:nth-child(1){
    position: static;
}

.table-body>div>div>div:nth-child(2){
    color: #007bff;
}

.table-body>div>div>div:nth-child(3){
    color: #6c757d;
}

.table-body>div>div>div:nth-child(4){
    color: #28a745;
}

.table-body>div>div>div:nth-child(5){
    color: rgba(255, 7, 58, 0.6);
}

.india-head>div:nth-child(2){
    color: #007bff;
}

.india-head>div:nth-child(3){
    color: #6c757d;
}

.india-head>div:nth-child(4){
    color: #28a745;
}

.india-head>div:nth-child(5){
    color: rgba(255, 7, 58, 0.6);
}




.disrict-seacrh>div>input{
   margin-left: 60px;
   margin-top: 3px;
}

.input-search{
    background: var(--stateTableColor);
    /* border: none !important; */
}

.ant-tooltip-content{
    height: 200px;
    overflow-y: scroll;
}

`, "",{"version":3,"sources":["webpack://./src/components/Table.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;AAEtB;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;;AAEvC;;;AAGA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,OAAO;IACP,sBAAsB;;IAEtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;;AAEzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,OAAO;IACP,wBAAgB;IAAhB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;;;;AAKA;GACG,iBAAiB;GACjB,eAAe;AAClB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".table{\n    padding: 40px 20px;\n    \n}\n\n\n.table-head {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    grid-row-gap: 10px;\n    grid-column-gap:10px ;\n    /* position: sticky; */\n}\n\n.india-head>div{\n    /* background:#6c757d !important; */\n    \n}\n\n\n.table-body{\n    max-height: calc(100vh - 440px);\n    overflow-y: scroll;\n}\n\n.table-head>div{\n    font-size: 15px;\n    font-weight: 900;\n    padding: 1.25rem 0.5rem 0.75rem;\n    text-align: center;\n    /* background: #212130 ; */\n    justify-content: space-between;\n    left: 0;\n    /* position: sticky; */\n  \n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0.25rem;\n    /* padding: 0.5rem; */\n\n}\n\n.table-body>div{\n    font-size: 15px;\n}\n\n.table-body>div>div:nth-child(1) {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    grid-row-gap: 10px;\n    grid-column-gap:10px ;\n}\n\n.table-body>div>div:nth-child(1)>div{\n    \n    font-weight: 900;\n    padding: 1.25rem 0.5rem 0.75rem;\n    text-align: center;\n    /* background: #212130 !important; */\n    justify-content: space-between;\n    left: 0;\n    position: sticky;\n    z-index: 11;\n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0.25rem;\n    /* padding: 0.5rem; */\n}\n\n\n\n.table-body>div:nth-child(1){\n    position: static;\n}\n\n.table-body>div>div>div:nth-child(2){\n    color: #007bff;\n}\n\n.table-body>div>div>div:nth-child(3){\n    color: #6c757d;\n}\n\n.table-body>div>div>div:nth-child(4){\n    color: #28a745;\n}\n\n.table-body>div>div>div:nth-child(5){\n    color: rgba(255, 7, 58, 0.6);\n}\n\n.india-head>div:nth-child(2){\n    color: #007bff;\n}\n\n.india-head>div:nth-child(3){\n    color: #6c757d;\n}\n\n.india-head>div:nth-child(4){\n    color: #28a745;\n}\n\n.india-head>div:nth-child(5){\n    color: rgba(255, 7, 58, 0.6);\n}\n\n\n\n\n.disrict-seacrh>div>input{\n   margin-left: 60px;\n   margin-top: 3px;\n}\n\n.input-search{\n    background: var(--stateTableColor);\n    /* border: none !important; */\n}\n\n.ant-tooltip-content{\n    height: 200px;\n    overflow-y: scroll;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
